  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_FeeInquiryService = {
  wu_feeinquirymultiple
};
//----------------------------------------------------------------------------------------------------
function wu_feeinquirymultiple(reqData){
  const methName = "wu_feeinquirymultiple ";
  let localUrl = "";
  if(api.isCaptchaEnabled){ localUrl = api.url + "/wbrestservices-1.0.0/wbservice/feeinquirymultiple?cardNo=&promoCode="+reqData.promoCode+"&cardPromoCode=&recaptchaVerify="+reqData.recaptchaVerify.replace(/"/g,""); }
  else                    { localUrl = api.url + "/wbrestservices-1.0.0/wbservice/feeinquirymultiple?cardNo=&promoCode="+reqData.promoCode+"&cardPromoCode="; }

  var headers = null;
  if(localStorage.getItem("isLoggedIn")==="true"){
    headers = {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "tokenID"                     : localStorage.getItem("tokenID"),
      "Authorization"               : "Bearer "+ localStorage.getItem("accessToken"),
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  }
  else{
    headers = {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  }

  const config = {
    timeout: api.netTimeout,
    headers: headers
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {
    "orig_ctry_wu"              : reqData.orig_ctry_wu,//"GR",
  	"orig_curr"                 : reqData.orig_curr,//"EUR",
  	"dest_ctry_wu"              : reqData.dest_ctry_wu,//"AL",
  	"dest_curr"                 : reqData.dest_curr,//"EUR",
  	"delivery_service_code"     : "",
  	"amount_to_send"            : reqData.amount_to_send,//"1",
  	"payout_amount"             : reqData.payout_amount,//"",
  	"calculate_based_on_payout" : reqData.calculate_based_on_payout,//"false"
    "txnChannelTypes"           : reqData.txnChannelTypes,
  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
